/*
 * "How Did You Find Us?" popup behavior.
 *
 * - Shows once ~5s after landing, then not again for the configured cooldown (30 days).
 *   Remembered in localStorage AND a first-party cookie; if neither can be written the popup
 *   does not show at all (so nobody is nagged on every page).
 * - Never shows on the cart page or KX Graphics product pages, and waits while the visitor is
 *   typing in a field, a drawer/menu is open, or the tab is hidden.
 * - Recording: when a Google Sheet recorder URL is configured, the code is revealed only after the
 *   Sheet confirms the answer was saved. When it is not configured, the answer is saved as a cart
 *   attribute ("How did you find us?") that appears on the order, and the code is revealed only
 *   after Shopify confirms that save. The cart attribute is also written as best-effort when the
 *   Sheet is configured. Cart ITEMS are never touched.
 * - Coordinates with the email popup through <html data-mc-survey="pending|open|held"> and the
 *   sessionStorage flag mc_fyu_session (the email popup waits for the next visit).
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-mc-fyu]');
  if (!root) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var CODE = (root.getAttribute('data-code') || '').trim();
  if (!CODE) return;

  function num(value, fallback) {
    var n = parseFloat(value);
    return isNaN(n) || n < 0 ? fallback : n;
  }

  var DELAY_MS = num(root.getAttribute('data-delay'), 5) * 1000;
  var COOLDOWN_DAYS = num(root.getAttribute('data-cooldown-days'), 30) || 30;
  var SUPPRESS_PAGE =
    root.getAttribute('data-suppress') === 'true' || !!document.querySelector('[class*="kx-decal"]');

  var LS_NEXT = 'mc_fyu_next_ts';
  var COOKIE = 'mc_fyu';
  var SESSION_FLAG = 'mc_fyu_session';
  var ATTR_KEY = 'How did you find us?';
  var VERSION = 'popup-v1';

  var card = root.querySelector('.mc-fyu__card');
  var form = root.querySelector('[data-mc-fyu-form]');
  var questionPanel = root.querySelector('[data-mc-fyu-question]');
  var successPanel = root.querySelector('[data-mc-fyu-success]');
  var heading = root.querySelector('[data-mc-fyu-heading]');
  var successHeading = root.querySelector('[data-mc-fyu-success-heading]');
  var submitBtn = root.querySelector('[data-mc-fyu-submit]');
  var errorEl = root.querySelector('[data-mc-fyu-error]');
  var hp = root.querySelector('[data-mc-fyu-hp]');
  var copyBtn = root.querySelector('[data-mc-fyu-copy]');
  var applyBtn = root.querySelector('[data-mc-fyu-apply]');
  var liveEl = root.querySelector('[data-mc-fyu-live]');
  var submitLabel = submitBtn ? submitBtn.textContent : '';

  /* ---------- storage helpers (every access guarded) ---------- */

  function lsGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function lsSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
      return true;
    } catch (e) {
      return false;
    }
  }

  function cookieHas(name) {
    try {
      return ('; ' + document.cookie).indexOf('; ' + name + '=') !== -1;
    } catch (e) {
      return false;
    }
  }

  function cookieSet(name, days) {
    try {
      document.cookie =
        name + '=1; max-age=' + Math.round(days * 86400) + '; path=/; SameSite=Lax' +
        (window.location.protocol === 'https:' ? '; Secure' : '');
    } catch (e) {}
    return cookieHas(name);
  }

  function canRemember() {
    try {
      window.localStorage.setItem('mc_fyu_probe', '1');
      window.localStorage.removeItem('mc_fyu_probe');
      return true;
    } catch (e) {}
    try {
      document.cookie = 'mc_fyu_probe=1; max-age=60; path=/; SameSite=Lax';
      var ok = cookieHas('mc_fyu_probe');
      document.cookie = 'mc_fyu_probe=; max-age=0; path=/; SameSite=Lax';
      return ok;
    } catch (e2) {
      return false;
    }
  }

  function isEligible() {
    var next = parseInt(lsGet(LS_NEXT) || '0', 10);
    if (Date.now() < next) return false;
    if (cookieHas(COOKIE)) return false;
    return true;
  }

  function rememberSeen() {
    lsSet(LS_NEXT, String(Date.now() + COOLDOWN_DAYS * 86400000));
    cookieSet(COOKIE, COOLDOWN_DAYS);
    try {
      window.sessionStorage.setItem(SESSION_FLAG, '1');
    } catch (e) {}
  }

  function setState(value) {
    if (value) document.documentElement.setAttribute('data-mc-survey', value);
    else document.documentElement.removeAttribute('data-mc-survey');
  }

  /* ---------- eligibility ---------- */

  if (!isEligible() || !canRemember()) return;

  if (SUPPRESS_PAGE) {
    /* Eligible visitor on a page where the popup must stay away (cart / KX customization).
       Keep the email popup quiet too, so the survey can go first on a later page. */
    setState('held');
    return;
  }

  setState('pending');

  /* ---------- open / close ---------- */

  var lastFocus = null;
  var isOpen = false;
  var waitTimer = null;

  function isBusy() {
    if (document.hidden) return true;
    var a = document.activeElement;
    if (a && a !== document.body && !root.contains(a)) {
      if (/^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) || a.isContentEditable) return true;
    }
    if (document.body && document.body.classList.contains('overflow-hidden')) return true;
    if (document.querySelector('cart-drawer.active, .mc-email-popup--visible')) return true;
    return false;
  }

  function attempt(waited) {
    if (isBusy()) {
      if (waited >= 90000) {
        setState('');
        return;
      }
      waitTimer = window.setTimeout(function () {
        attempt(waited + 1500);
      }, 1500);
      return;
    }
    open();
  }

  function focusables() {
    return Array.prototype.slice
      .call(card.querySelectorAll('button, input, [href], [tabindex]:not([tabindex="-1"])'))
      .filter(function (el) {
        if (el.disabled || el.closest('[hidden]') || el.closest('.mc-fyu__hp')) return false;
        return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
      });
  }

  function onKeydown(e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      close();
      return;
    }
    if (e.key !== 'Tab') return;
    var items = focusables();
    if (!items.length) {
      e.preventDefault();
      return;
    }
    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;
    if (e.shiftKey && (active === first || !card.contains(active))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (active === last || !card.contains(active))) {
      e.preventDefault();
      first.focus();
    }
  }

  function open() {
    if (isOpen) return;
    isOpen = true;
    rememberSeen();
    setState('open');
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    document.documentElement.classList.add('mc-fyu-lock');
    /* Flush layout so the fade-in transition runs, then reveal (no requestAnimationFrame: it is
       paused in background tabs and would leave the popup invisible). */
    void root.offsetWidth;
    window.setTimeout(function () {
      root.classList.add('is-visible');
    }, 20);
    document.addEventListener('keydown', onKeydown, true);
    if (heading) heading.focus({ preventScroll: true });
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-visible');
    document.documentElement.classList.remove('mc-fyu-lock');
    document.removeEventListener('keydown', onKeydown, true);
    setState('');
    window.setTimeout(function () {
      root.classList.remove('is-open');
    }, 300);
    if (lastFocus && typeof lastFocus.focus === 'function' && document.contains(lastFocus)) {
      try {
        lastFocus.focus({ preventScroll: true });
      } catch (e) {}
    }
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-mc-fyu-close]') || e.target.hasAttribute('data-mc-fyu-backdrop')) {
      close();
    }
  });

  /* ---------- selecting + submitting ---------- */

  function selected() {
    var r = form.querySelector('input[name="how_found"]:checked');
    return r ? r.value : '';
  }

  function showError(message) {
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  function clearError() {
    errorEl.hidden = true;
    errorEl.textContent = '';
  }

  form.addEventListener('change', function () {
    clearError();
    submitBtn.setAttribute('aria-disabled', selected() ? 'false' : 'true');
  });

  function timedFetch(url, options, ms) {
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = window.setTimeout(function () {
      if (ctrl) ctrl.abort();
    }, ms);
    if (ctrl) options.signal = ctrl.signal;
    return fetch(url, options).then(
      function (res) {
        window.clearTimeout(timer);
        return res;
      },
      function (err) {
        window.clearTimeout(timer);
        throw err;
      }
    );
  }

  /* Saves the answer on the cart; it then appears on the order under "Additional details".
     Only the cart attributes are written - items, quantities and properties are untouched. */
  function recordOnCart(answer) {
    var attributes = {};
    attributes[ATTR_KEY] = answer;
    return timedFetch(
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart/update.js'
        : '/cart/update.js',
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attributes })
      },
      8000
    )
      .then(function (res) {
        return res.ok;
      })
      .catch(function () {
        return false;
      });
  }

  /* Sends the single anonymous answer to the owner's Google Sheet web app. */
  function recordInSheet(answer, endpoint) {
    return timedFetch(
      endpoint,
      {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        redirect: 'follow',
        body: JSON.stringify({ answer: answer, version: VERSION })
      },
      10000
    )
      .then(function (res) {
        return res.ok ? res.json() : { ok: false };
      })
      .then(function (json) {
        return !!(json && json.ok === true);
      })
      .catch(function () {
        return false;
      });
  }

  var submitting = false;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (submitting) return;
    var answer = selected();
    if (!answer) {
      showError('Please choose one option to unlock your code.');
      return;
    }
    clearError();

    /* A bot filled the hidden field: pretend to succeed, record nothing. */
    if (hp && hp.value) {
      showSuccess();
      return;
    }

    submitting = true;
    submitBtn.setAttribute('aria-busy', 'true');
    submitBtn.textContent = 'Saving...';

    var endpoint = (root.getAttribute('data-endpoint') || '').trim();
    var cartSave = recordOnCart(answer);
    var primary = endpoint ? recordInSheet(answer, endpoint) : cartSave;

    Promise.all([primary, cartSave]).then(function (results) {
      submitting = false;
      submitBtn.removeAttribute('aria-busy');
      submitBtn.textContent = submitLabel;
      if (results[0]) {
        showSuccess();
      } else {
        showError('We could not save your answer just now. Please check your connection and try again.');
      }
    });
  });

  function showSuccess() {
    questionPanel.hidden = true;
    successPanel.hidden = false;
    if (successHeading) successHeading.focus({ preventScroll: true });
  }

  /* ---------- copy + apply ---------- */

  function announce(message) {
    if (!liveEl) return;
    liveEl.textContent = '';
    window.setTimeout(function () {
      liveEl.textContent = message;
    }, 50);
  }

  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '-1000px';
    document.body.appendChild(ta);
    ta.select();
    var ok = false;
    try {
      ok = document.execCommand('copy');
    } catch (e) {}
    document.body.removeChild(ta);
    return ok;
  }

  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      function done(ok) {
        copyBtn.textContent = ok ? 'Copied!' : 'Press Ctrl+C';
        announce(ok ? 'Code ' + CODE + ' copied to clipboard' : 'Select the code and copy it manually');
        window.setTimeout(function () {
          copyBtn.textContent = 'Copy code';
        }, 2200);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(CODE).then(
          function () {
            done(true);
          },
          function () {
            done(fallbackCopy(CODE));
          }
        );
      } else {
        done(fallbackCopy(CODE));
      }
    });
  }

  /* Shopify's own discount link: stores the code for checkout, then returns to this same page.
     It does not add, remove or change anything in the cart. */
  if (applyBtn) {
    applyBtn.addEventListener('click', function () {
      var back = window.location.pathname + window.location.search;
      window.location.href = '/discount/' + encodeURIComponent(CODE) + '?redirect=' + encodeURIComponent(back);
    });
  }

  /* ---------- go ---------- */

  waitTimer = window.setTimeout(function () {
    attempt(0);
  }, DELAY_MS);
})();
